export default "__VITE_ASSET__Dp_Nh9wA__"